import { render, staticRenderFns } from "./DateInputField.vue?vue&type=template&id=3d5e354e&"
import script from "./DateInputField.vue?vue&type=script&lang=js&"
export * from "./DateInputField.vue?vue&type=script&lang=js&"
import style0 from "./DateInputField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports